import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './expand.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export default function Collapse(props: IconProps) {
  return <Icon tw="fill-current" className={props.className} />;
}
